import { Box, Grid, Link, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import InfoItem from 'modules/procurement/components/InfoItem'
import type { PurchaseOrder } from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetailPanel/types'
import { PurchaseOrderStatusLabel } from 'modules/procurement/components/purchaseOrders/PurchaseOrderStatusLabel'

interface Props {
  purchaseOrder: PurchaseOrder
}

const GeneralInfo = ({ purchaseOrder }: Props) => {
  const {
    access: { locale },
  } = useCurrentSession()
  return (
    <Box gap="s12">
      <Text weight="bold" size="200" color="grey800" caps>
        {i18n.t('procurement.purchase_orders.detail.heading')}
      </Text>
      <Grid variant="fixed">
        <Box gridColSpan={{ xxs: 6 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.info.po_number')}
            item={
              purchaseOrder.status && (
                <Box flexDirection="row" gap="s8">
                  <Text weight="medium" size="200" color="grey1000">
                    {purchaseOrder.formattedPoNumber}
                  </Text>
                  <PurchaseOrderStatusLabel status={purchaseOrder.status} />
                </Box>
              )
            }
          />
        </Box>
        <Box gridColSpan={{ xxs: 6 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.info.type')}
            textItem={
              purchaseOrder.purchaseRequest?.type ? purchaseOrder.purchaseRequest.type.name : '-'
            }
          />
        </Box>
        <Box gridColSpan={{ xxs: 6 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.info.description')}
            textItem={purchaseOrder.description}
          />
        </Box>
        <Box gridColSpan={{ xxs: 6 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.info.request_date')}
            textItem={dateBackendDateTimeToUI(purchaseOrder.date)}
          />
        </Box>
        <Box gridColSpan={{ xxs: 6 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.info.deadline')}
            textItem={
              purchaseOrder.deadline ? dateBackendDateTimeToUI(purchaseOrder.deadline) : '-'
            }
          />
        </Box>
        <Box gridColSpan={{ xxs: 12 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.info.cost')}
            item={
              purchaseOrder.cost && (
                <Text weight="medium" size="200" color="grey1000">
                  {MoneyWithCurrency({
                    amount: Number(purchaseOrder.cost.cents),
                    currency: purchaseOrder.cost.currency,
                    locale,
                  })}
                </Text>
              )
            }
          />
        </Box>
        {purchaseOrder.purchaseRequest && (
          <Box gridColSpan={{ xxs: 12 }}>
            <InfoItem
              label={i18n.t('procurement.purchase_requests.detail.info.url')}
              item={
                purchaseOrder.purchaseRequest.url ? (
                  <Link.Href href={purchaseOrder.purchaseRequest.url} target="_blank">
                    {purchaseOrder.purchaseRequest.url}
                  </Link.Href>
                ) : (
                  <Text weight="normal" size="300" color="grey1000">
                    -
                  </Text>
                )
              }
            />
          </Box>
        )}
      </Grid>
    </Box>
  )
}

export default GeneralInfo
